import React from "react";

import classNames from "classnames";

import { IMAGE_FORMATS } from "../../../constants/ratio";

import type { JSX, ReactNode } from "react";

import type { HorizontalImageFormat } from "../../../constants/ratio";

interface PictureRatioWrapperProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

export function PictureRatioWrapper({
  children,
  className,
  onClick,
}: PictureRatioWrapperProps): JSX.Element {
  const wrapperClassName = classNames(
    className,
    "m-[0.625rem] flex cursor-pointer flex-col",
  );
  return (
    <div className={wrapperClassName} onClick={onClick}>
      {children}
    </div>
  );
}

interface PictureRatioContainerProps {
  children: ReactNode;
  isSelected: boolean;
}

export function PictureRatioContainer({
  children,
  isSelected,
}: PictureRatioContainerProps): JSX.Element {
  const containerClassNames = classNames("flex gap-[6px] border-2", {
    "border-primary": isSelected,
    "border-transparent": !isSelected,
  });
  return <div className={containerClassNames}>{children}</div>;
}

interface PictureRatioProps {
  children: ReactNode;
  ratio?: HorizontalImageFormat;
  isSelected: boolean;
  className?: string;
}

export function PictureRatio({
  children,
  ratio,
  isSelected,
  className,
}: PictureRatioProps): JSX.Element {
  const is169Ratio = ratio === IMAGE_FORMATS.FORMAT_16_9;
  const is166Ratio = ratio === IMAGE_FORMATS.FORMAT_16_6;
  const is163Ratio = ratio === IMAGE_FORMATS.FORMAT_16_3;

  const pictureRatioClassNames = classNames(
    className,
    "flex items-center justify-center",
    {
      "aspect-16/9": is169Ratio,
      "aspect-16/6": is166Ratio,
      "aspect-16/3": is163Ratio,
      "bg-muted": isSelected,
      "bg-surface-muted": !isSelected,
    },
  );
  return <div className={pictureRatioClassNames}>{children}</div>;
}

interface PictureRatioLabelProps {
  children: ReactNode;
  isSelected: boolean;
}

export function PictureRatioLabel({
  children,
  isSelected,
}: PictureRatioLabelProps): JSX.Element {
  const labelClassNames = classNames(
    "flex justify-center text-[16px] font-semibold text-muted-foreground",
    {
      "text-primary": isSelected,
      "text-muted-foreground": !isSelected,
    },
  );
  return <span className={labelClassNames}>{children}</span>;
}
